<template>
  <span v-if="name === 'open'">
    <i :class="getIconClass('far fa-envelope-open', 'text-red-400')" alt="opened" />
  </span>
  <span v-else-if="name === 'called'">
    <i :class="getIconClass('fas fa-mobile-alt', 'text-pink-400')" />
    <i :class="getIconClass('ml-2 fas fa-sign-in-alt', 'text-pink-400')" />
  </span>
  <span v-else-if="name === 'incoming text'">
    <i :class="getIconClass('fas fa-sign-in-alt', 'text-red-400')" />
    <i :class="getIconClass('ml-2 fas fa-sms', 'text-red-400')" />
  </span>
  <span v-else-if="name === 'incoming call'">
    <i :class="getIconClass('fas fa-sign-in-alt', 'text-red-400')" />
    <i :class="getIconClass('ml-2 fas fa-mobile-alt', 'text-red-400')" />
  </span>
  <span v-else-if="name === 'text'">
    <i :class="getIconClass('fas fa-sms', 'text-green-400')" />
    <i :class="getIconClass('ml-2 fas fa-sign-out-alt', 'text-green-400')" />
  </span>
  <span v-else-if="name === 'voicemail'">
    <i :class="getIconClass('fas fa-voicemail', 'text-orange-500')" />
  </span>
  <span v-else-if="name === 'click'">
    <i :class="getIconClass('far fa-hand-pointer', 'text-gray-300')" />
  </span>
  <span v-else-if="name === 'processor assigned'">
    <i :class="getIconClass('fas fa-user-plus', 'text-blue-400')" />
  </span>
  <span v-else-if="name === 'floify sent'">
    <i :class="getIconClass('far fa-id-card', 'text-blue-400')" />
  </span>
  <span v-else-if="name === 'reminder'">
    <i :class="getIconClass('fas fa-user-clock', 'text-blue-400')" />
  </span>
  <span v-else-if="name === 'email'">
    <i :class="getIconClass('far fa-envelope', 'text-green-400')" />
  </span>
  <span v-else-if="name === 'note'">
    <i :class="getIconClass('far fa-sticky-note', 'text-blue-400')" />
  </span>
  <span v-else-if="name === 'status'">
    <i :class="getIconClass('fas fa-exchange-alt', 'text-blue-400')" />
  </span>
  <span v-else-if="name === 'admin'">
    <i :class="getIconClass('fas fa-cogs', 'text-gray-400')" />
  </span>
  <span v-else-if="name === 'card'">
    <i :class="getIconClass('fas fa-mail-bulk', 'text-indigo-400')" />
  </span>
  <span v-else-if="name === 'assigned'">
    <i :class="getIconClass('fas fa-cogs', 'text-yellow-300')" />
  </span>
  <span v-else-if="name === 'unsubscribe'">
    <i :class="getIconClass('fas fa-user-slash', 'text-red-800')" />
  </span>
  <span v-else-if="name === 'error'">
    <i :class="getIconClass('fas fa-exclamation-triangle', 'text-red-400')" />
  </span>
  <span v-else-if="name === 'tag'">
    <i :class="getIconClass('fas fa-tag', 'text-yellow-300')" />
  </span>
  <span v-else-if="name === 'auto'">
    <i :class="getIconClass('fas fa-robot', 'text-indigo-800')" />
  </span>
  <span v-else-if="name === 'alert'">
    <i :class="getIconClass('fas fa-exclamation-triangle', 'text-orange-400')" />
  </span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    defaultClasses: {
      type: String,
      default: '', // Default global classes for all icons
    },
    customClasses: {
      type: Object,
      default: () => ({}), // Custom classes for individual icons
    },
  },
  methods: {
    getIconClass(baseClass, defaultClass) {
      const customClass = this.customClasses[this.name] || 'text-2xl'
      return `${customClass} ${baseClass} ${defaultClass}`.trim()
    },
  },
}
</script>
